import { render, staticRenderFns } from "./nice-pay.vue?vue&type=template&id=add17ec6&"
import script from "./nice-pay.vue?vue&type=script&lang=js&"
export * from "./nice-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports